import ExpanderList from '@rio-cloud/rio-uikit/ExpanderList';
import { useEffect, useState } from 'react';

import type { OrderDetailsDocuments } from '#api-bridge/types/orderDetailsDocuments.ts';
import type { Material } from '#domain/Material.ts';
import { isServiceOrder } from '#domain/Order.ts';
import type { OrderWithSortableKey } from '#utils/orders.util.ts';

import { OrderState } from '../OrderState.tsx';
import { ServiceTypeName } from '../ServiceTypeName.tsx';
import { getOrderExpanderItems } from './OrderExpanderItems.tsx';

type OrderDetailsProps = {
    order?: OrderWithSortableKey;
    materials?: Material[];
    documents?: OrderDetailsDocuments;
};

export const OrderDetails = ({ order, materials, documents }: OrderDetailsProps) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState<number | undefined>(0);

    useEffect(() => {
        if (!selectedItemIndex) {
            setSelectedItemIndex(0);
        }
    }, [order?.id]);

    if (!order) {
        return null;
    }

    const expanderItems = getOrderExpanderItems({
        documents,
        order,
        materials,
        setSelectedItemIndex,
        selectedItemIndex,
    });
    return (
        <div data-testid='order-details'>
            <div className='padding-x-15 padding-bottom-15'>
                <div className='text-size-h4 line-height-125rel text-medium'>
                    {isServiceOrder(order) ? <ServiceTypeName value={order.number} /> : order.number}
                </div>
                {!isServiceOrder(order) && <div>{order.customerName}</div>}
                {isServiceOrder(order) && <div className='padding-top-5'>{order.description}</div>}
                {order.status && (
                    <div className='padding-top-5'>
                        <OrderState status={order.status} />
                    </div>
                )}
            </div>
            <ExpanderList className='border border-left-none border-right-none' rounded={false} items={expanderItems} />
        </div>
    );
};
